import { render, staticRenderFns } from "./addBusinessApply.vue?vue&type=template&id=6d1813ee&"
import script from "./addBusinessApply.vue?vue&type=script&lang=js&"
export * from "./addBusinessApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports